module.exports = __webpack_public_path__ + "static/media/brand-refresh-current-icon.2eaaabef.svg";